import {
  createSlice
} from '@reduxjs/toolkit'
import { imagePosition } from '../../components/BackgroundImage'

export const GAME_STATUS = {
  WAITING_START: 0,
  IDLE: 1,
  FLIP_1: 2,
  MATCHING: 3,
  GAMEOVER: 4
}

function shuffle(arr) {
  let currentIndex = arr.length, randomIndex
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    [arr[currentIndex], arr[randomIndex]] = [arr[randomIndex], arr[currentIndex]]
  }
  return arr
}

export const getInitialCards = (levelVocas) => {
  let initialCards = [], count = 0

  levelVocas.map((d,i) => {
    let pairInfo = {
      id: count,
      pairId: i,
      pairType: 'word',
      paired: false,
      matching: false,
      secondMatching: false
    }

    initialCards.push({ ...pairInfo, pairType: 'img' })
    initialCards.push({ ...pairInfo, ...d })
  })

  let shuffedCards = shuffle(initialCards)
  shuffedCards.map((c,i) => {
    if (c.pairType === 'img') {
      const { x, y } = imagePosition(c.pairId)
      shuffedCards[i].posX = x
      shuffedCards[i].posY = y
    }
    
    shuffedCards[i].id = count
    count++
  })

  return shuffedCards
}

const initialState = {
  cardIds: [],
  cards: {},
  pickedCardId: null,
  pairedCardIds: [],
  latestPairedCard: null,
  status: GAME_STATUS.WAITING_START
}

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    startGame(state, action) {
      let cards = {}, cardIds = []
      action.payload.map(card => {
        cardIds.push(card.id)
        cards[card.id] = card
      })
      state.cardIds = cardIds
      state.cards = cards

      state.status = GAME_STATUS.IDLE
      state.pickedCardId = null
      state.pairedCardIds = []
      state.latestPairedCard = null
    },
    initGameStatus(state, action) {
      state.status = GAME_STATUS.WAITING_START
    },
    pickCard(state, action) {
      const currCardId = action.payload
      const currCard = state.cards[currCardId]

      if (state.pickedCardId === null) {
        currCard.matching = true
        state.pickedCardId = currCardId
        state.status = GAME_STATUS.FLIP_1
      } else {
        const prevCardId = state.pickedCardId
        const prevCard = state.cards[prevCardId]

        if (currCard.pairId === prevCard.pairId) {
          // paired
          currCard.paired = true
          prevCard.paired = true
          state.pairedCardIds.push(currCard.pairId)
          state.latestPairedCard = currCard.pairType === 'word' ? currCard : prevCard
        }

        prevCard.matching = true
        currCard.matching = true
        currCard.secondMatching = true
        state.status = GAME_STATUS.MATCHING
      }

      if (state.pairedCardIds.length >= state.cardIds.length / 2) {
        state.status = GAME_STATUS.GAMEOVER
      }
    },
    releaseMatchingCard(state, action) {
      const currCardId = action.payload
      const currCard = state.cards[currCardId]
      
      if (currCard.secondMatching === true) {

        const prevCardId = state.pickedCardId
        const prevCard = state.cards[prevCardId]

        prevCard.matching = false
        currCard.matching = false
        currCard.secondMatching = false
        state.pickedCardId = null

        if (state.status !== GAME_STATUS.GAMEOVER) {
          state.status = GAME_STATUS.IDLE
        }
      }
    }
  }
})

export const {
  startGame,
  pickCard,
  initGameStatus,
  releaseMatchingCard
} = gameSlice.actions

export const selectGameStatus = state => state.game.status
export const selectAllCards = state => Object.values(state.game.cards)
export const selectLatestPairedCard = state => state.game.latestPairedCard

export default gameSlice.reducer
